/**
 * LandingPage — entry screen with solo, create room, and join room options.
 */

import { useState } from 'react';

export default function LandingPage({ onSoloGame, onCreateRoom, onJoinRoom, error }) {
  const [modal, setModal] = useState(null); // "create" | "join" | null
  const [playerName, setPlayerName] = useState('');
  const [roomCode, setRoomCode] = useState('');

  function handleCreate(e) {
    e.preventDefault();
    const name = playerName.trim();
    if (!name) return;
    onCreateRoom(name);
  }

  function handleJoin(e) {
    e.preventDefault();
    const name = playerName.trim();
    const code = roomCode.trim().toUpperCase();
    if (!name || !code) return;
    onJoinRoom(code, name);
  }

  return (
    <div className="landing">
      <div className="landing-card">
        <h1 className="landing-title"><span className="logo-l">L</span><span className="logo-e">e</span><span className="logo-x">x</span><span className="logo-i">i</span><span className="logo-quest">Quest</span></h1>
        <div className="landing-stripe" />
        <p className="landing-subtitle">Navigate the semantic space between words</p>
        {error && <div className="toast-error landing-error">{error}</div>}

        <div className="landing-buttons">
          <button className="btn-landing btn-solo" onClick={onSoloGame}>
            Solo Game
          </button>
          <button className="btn-landing btn-create" onClick={() => { setModal('create'); setPlayerName(''); }}>
            Create Room
          </button>
          <button className="btn-landing btn-join" onClick={() => { setModal('join'); setPlayerName(''); setRoomCode(''); }}>
            Join Room
          </button>
        </div>
      </div>

      {/* Name input modal — create */}
      {modal === 'create' && (
        <div className="landing-overlay" onClick={() => setModal(null)}>
          <form className="landing-modal" onClick={e => e.stopPropagation()} onSubmit={handleCreate}>
            <button type="button" className="how-close" onClick={() => setModal(null)}>{'\u00d7'}</button>
            <h2 className="how-title">Create Room</h2>
            <label className="landing-label">
              Display Name
              <input
                className="landing-input"
                type="text"
                maxLength={20}
                autoFocus
                value={playerName}
                onChange={e => setPlayerName(e.target.value)}
                placeholder="Enter your name"
              />
            </label>
            <button type="submit" className="btn-new btn-modal-action" disabled={!playerName.trim()}>
              Create
            </button>
          </form>
        </div>
      )}

      {/* Name + code input modal — join */}
      {modal === 'join' && (
        <div className="landing-overlay" onClick={() => setModal(null)}>
          <form className="landing-modal" onClick={e => e.stopPropagation()} onSubmit={handleJoin}>
            <button type="button" className="how-close" onClick={() => setModal(null)}>{'\u00d7'}</button>
            <h2 className="how-title">Join Room</h2>
            <label className="landing-label">
              Display Name
              <input
                className="landing-input"
                type="text"
                maxLength={20}
                autoFocus
                value={playerName}
                onChange={e => setPlayerName(e.target.value)}
                placeholder="Enter your name"
              />
            </label>
            <label className="landing-label">
              Room Code
              <input
                className="landing-input landing-input-code"
                type="text"
                maxLength={6}
                value={roomCode}
                onChange={e => setRoomCode(e.target.value.toUpperCase())}
                placeholder="ABCDEF"
              />
            </label>
            <button type="submit" className="btn-new btn-modal-action" disabled={!playerName.trim() || roomCode.trim().length < 6}>
              Join
            </button>
          </form>
        </div>
      )}
    </div>
  );
}
